<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      @close="handleClose"
      center
      append-to-body
    >
      <el-form :model="form" label-width="80px">
        <el-form-item label="输入原因" style="width: 100%">
          <el-dropdown @command="getReason">
            <el-input v-model="form.input" placeholder="请输入内容">
              <i slot="suffix" class="el-icon-arrow-down"></i>
            </el-input>
            <el-dropdown-menu style="width: 200px" slot="dropdown">
              <el-dropdown-item
                v-for="item in reasonList"
                :command="item.value"
                :key="item.value"
              >
                {{ item.value }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import showdialog from "@/minxs/showdialog";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  mixins: [showdialog],
  data() {
    return {
      form: {
        input: "",
      },
      reasonList: [
        {
          id: 0,
          value: "清洗车",
        },
        {
          id: 1,
          value: "军警车",
        },
      ],
    };
  },

  methods: {
    handleClick() {
      // console.log(this.form);
      this.$emit("getReason", this.form.input);
      this.$emit("update:showdialog", false);
    },
    getReason(str) {
      this.form.input = str;
    },
  },
};
</script>
